const ExternalUrls = {
    facebook: 'https://www.facebook.com/FanCollex',
    instagram: 'https://www.instagram.com/FanCollex/',
    twitter: 'https://twitter.com/FanCollex',
    termsOfUse: 'https://www.FanCollex.com/policies/terms-of-service',
    privacyPolicy: 'https://www.FanCollex.com/pages/privacy-policy',
    //appStore: 'https://apps.apple.com/app/splink-collectibles-2-0/id1618225751',
    //googlePlay:
        //'https://play.google.com/store/apps/details?id=com.splink.app',
};

export default ExternalUrls;
